import $ from 'jquery';
window.$ = window.jQuery = $;
var pagename = location.pathname.substring(location.pathname.lastIndexOf("/") + 1);
if(pagename=="category") {
var text = $('.textreg'),
		btn = $('.know-more'),
		h = text[0].scrollHeight; 
		if(h > 165) {
			btn.addClass('Less');
			btn.css('display', 'block');
		}
		btn.click(function(e) 
		{
		  e.stopPropagation();
		  if (btn.hasClass('Less')) {
			  btn.removeClass('Less');
			  btn.addClass('More');
			  btn.html('Show Less <img class="ps-1" src="images/white-arrow.svg" alt="">');
			  text.animate({'height': h});
		  } else {
			  btn.addClass('Less');
			  btn.removeClass('More');
			  btn.html('Show More <img class="ps-1" src="images/white-arrow.svg" alt="">');
			  text.animate({'height': '165px'});
		  }  
 });

	}

	if(pagename==1) {
		var textvendor = $('.textregvendor'),
		btnvendor = $('.know-more'),
		hvendor = textvendor[0].scrollHeight; 
		if(h > 287) {
			btnvendor.addClass('Less');
			btnvendor.css('display', 'block');
		}
		btnvendor.click(function(e) 
		{
		  e.stopPropagation();
		  if (btnvendor.hasClass('Less')) {
			  btnvendor.removeClass('Less');
			  btnvendor.addClass('More');
			  btnvendor.html('Show Less <img class="ps-1" src="../images/white-arrow.svg" alt="">');
			  textvendor.animate({'height': hvendor});
		  } else {
			  btnvendor.addClass('Less');
			  btnvendor.removeClass('More');
			  btnvendor.html('Show More <img class="ps-1" src="../images/white-arrow.svg" alt="">');
			  textvendor.animate({'height': '287px'});
		  }  
 });
 }

$(document).on("click", ".categorychange", function()
{
	$('#categoryModal').modal('show');
});

//about us
$(document).on("click", ".inventioninventorblock", function()
{
  	let id = $(this).data('tid');
  	let tid = $(this).data('tindex');
  	let author = "";
  	let Description = "";
  	let fileToUpload = [];
  	let indexid = "";
  	let companyName = "";
  	let i = 0;
  	let vendorrowdata = JSON.parse(localStorage.getItem("AllInventors"));
  	if (vendorrowdata == null)
  	{
		vendorrowdata = [];
  	}
  	let temp = [];
  	if (vendorrowdata.length != 0)
  	{
		for (i = 0; i < vendorrowdata.length; i++)
		{
		  	if (vendorrowdata[i]['templateTestimonial'] == tid)
		  	{
				temp = vendorrowdata[i];
				vendorrowdata.splice(i, 1);
		  	}
		}
  	}
  	if (temp.length != '0')
  	{
		if (temp['templateTestimonial'] == tid)
		{
		  author = temp['Author'];
		  Description = temp['Description'];
		  fileToUpload = temp['fileToUpload'];
		  indexid = temp['templateTestimonial'];
		  companyName = temp['companyName'];
		}
  	}
  	let invention_id = $(this).data('invention-id');
	$.ajax(
	{
		url: '/inventioninventorsave/' + id + '/' + invention_id + '/' + tid,
		type: 'POST',
		data: {
		  "_token": $("input[name='_token']").val(),
		  "author": author,
		  "Description": Description,
		  "fileToUpload": fileToUpload,
		  "indexid": indexid,
		  "companyName": companyName
		},
		success: function(response)
		{
		  $('#testimonialModal').html(response.html);
		  $('#testimonialModal').modal("show");
		}
	});
});
// copy url
$(document).on("click", ".copyUrlLink", function()
{
	let txt = document.getElementById('urllink');
	txt.select();
	document.execCommand('copy');
	alert('Copied to Clipboard!');
});

//Referral code Copy

$(document).on("click", ".copyReferralCode", function()
{
	let txt = document.getElementById('referalCode');
	txt.select();
	document.execCommand('copy');
	alert('Copied to Clipboard!');
});

//share link
$(document).on("click", ".inventionShareUrlLink", function()
{
	let id= $("#invid").val();
	$.ajax(
	{
		url: '/invention/share/url/'+ id,
		type: 'get',
		success: function(response)
		{
			alert("Linked shared successfully");
		},
		error: function (jqXHR, textStatus, errorThrown,response) 
		{
			alert('Internal error: ' + errorThrown);
		},
	});
});

//add invention

$(document).on("click", ".addnewinvention", function()
{
	let title = localStorage.getItem("Title");
	let Tagline = localStorage.getItem("Tagline");
	let inventorcategory = localStorage.getItem("inventionCategory");
	let description = localStorage.getItem("Description");
	let media_id = [];
	media_id = localStorage.getItem("allfiles");
	let content = [];
	let inventiontdata = JSON.parse(localStorage.getItem("inventionEntries"));
	content = inventiontdata;
	let inventors = [];
	inventors = JSON.parse(localStorage.getItem("AllInventors"));
	let inventiondownload = [];
	inventiondownload = JSON.parse(localStorage.getItem("Alldownloadfiles"));
	let downloaddelete = [];
	downloaddelete = JSON.parse(localStorage.getItem("deletedownloadfiles"));
	/*let formData = new FormData();
	formData.append("media_id", media_id);
	formData.append("deletedata",deletedata);*/
	if (title != null &&  description != null && media_id != null)
	{
		$.ajax(
		{
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url:  '/inventor/save/invention',
			type: 'POST',
			dataType: 'json',
			type: 'POST',
			data: {
				"downloaddelete": downloaddelete,
				"inventiondownload": inventiondownload,
				"inventors": inventors,
				"content": content,
				"media_id": media_id,
				"title": title,
				"Tagline": Tagline,
				"inventorcategory": inventorcategory,
				"description": description,
				"media_id": media_id
			},
			success: function(response)
			{
				alert("Invention created");
				let data1 = localStorage.getItem('newsletterSubscriptionModal');
				localStorage.clear();
				if(data1 != null)
				{
					localStorage.setItem('newsletterSubscriptionModal',data1);
				}
				let id = response.invention_id;
				let url =  '/inventor/edit/invention' + '/' + id
				window.location.href = url;
			}
		});
	}
	else
	{
		alert("Title, category, description and at least one media file are required to create an invention");
	}
});


//Edit Invention
$(document).on("click", ".saveinventiondata", function()
{
	let inventors = [];
	inventors = JSON.parse(localStorage.getItem("AllInventors"));
	let invention_id = $("#invid").val();
	let content = [];
	let deleteinventiontdata = [];
	let media_id = [];
	let deleteinventors = [];
	media_id = localStorage.getItem("allfiles");
	let inventiondownload = [];
	inventiondownload = JSON.parse(localStorage.getItem("Alldownloadfiles"));
	let downloaddelete = [];
	downloaddelete = JSON.parse(localStorage.getItem("deletedownloadfiles"));
	let inventiontdata = JSON.parse(localStorage.getItem("inventionEntries"));
	content = inventiontdata;
	deleteinventiontdata = JSON.parse(localStorage.getItem("deleteinventionEntries"));
	deleteinventors = JSON.parse(localStorage.getItem("inventordeleteEntries"));
	let title = localStorage.getItem("Title");
	let Tagline = localStorage.getItem("Tagline");
	let inventionCategory = localStorage.getItem("inventionCategory");
	let description = localStorage.getItem("Description");
	$.ajax(
	{
		headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url:  '/inventor/save/testimonial',
		type: 'POST',
		data: {
			"deleteinventors": deleteinventors,
			"media_id": media_id,
			"downloaddelete": downloaddelete,
			"inventors": inventors,
			"inventiondownload": inventiondownload,
			"inventionCategory": inventionCategory,
			"invention_id": invention_id,
			"title": title,
			"Tagline": Tagline,
			"description": description,
			"content": content,
			"deleteinventiontdata": deleteinventiontdata
		},
		success: function(response) {}
	});
	localStorage.removeItem("inventionCategory");
	localStorage.removeItem("InventionTitle");
	localStorage.removeItem("InventionDescription");
	localStorage.removeItem("inventionEntries");
	localStorage.removeItem("inventionData");
	localStorage.removeItem("delete-invention");
	localStorage.removeItem("deleteinventionEntries");
	localStorage.clear();
	alert("Data Updated")
	window.location.reload();
});

$(document).on("click", ".inventionupdateinventors", function()
{
	localStorage.setItem('inventionkey',true);
	let i = 0;
	$("#overlay").fadeIn(300);
	let author      = $("#modalauthor").val();
	let companyname = $("#modalcompanyname").val();
	let desc        = $("#modaldesc").val();
	let invention_id      = $("#modalinventionid").val();
	let testimonial_id      = $("#testid").val();
	let index_id      = $("#indexid").val();
	if(document.getElementById('modalfile').value == '')
	{
		let test_rows = [];
		let existingEntries = JSON.parse(localStorage.getItem("AllInventors"));
		if(existingEntries == null)
		{
			existingEntries = [];
		} 
		let temp = [];
		if(existingEntries.length != 0)
		{
			for(i = 0; i < existingEntries.length; i++)
			{
				if(existingEntries[i]['templateTestimonial'] == index_id)
				{
					temp = existingEntries[i];
					existingEntries.splice(i,1);
	 
				}
			}
		}
		if(temp.length != '0')
		{
			if(temp['templateTestimonial'] == index_id)
			{
	 
			    let test_line = {};
			    test_line.testimonial = temp['testimonial'];
			    test_line.invention_id = temp['invention_id'];
			    test_line.Author = author;
			    test_line.templateTestimonial = temp['templateTestimonial'];
			    test_line.companyName = companyname;
			    test_line.Description = desc;
			    test_line.fileToUpload = null;
			    test_rows.push(test_line);
			    localStorage.setItem("inventorData",JSON.stringify(test_rows));
			    existingEntries.push(test_line);
			    localStorage.setItem("AllInventors", JSON.stringify(existingEntries));
			}
			else
			{
				let test_line = {};
				test_line.testimonial = testimonial_id;
				test_line.invention_id = invention_id;
				test_line.Author = author;
				test_line.templateTestimonial = index_id;
				test_line.fileToUpload = null;
				test_line.companyName = companyname;
				test_line.Description = desc;
				test_rows.push(test_line);
				localStorage.setItem("inventorData",JSON.stringify(test_rows));
				existingEntries.push(test_line);
				localStorage.setItem("AllInventors", JSON.stringify(existingEntries));
			}
		}
		else
		{
			let test_line = {};
			test_line.testimonial = testimonial_id;
			test_line.invention_id = invention_id;
			test_line.Author = author;
			test_line.templateTestimonial = index_id;
			test_line.fileToUpload = null;
			test_line.companyName = companyname;
			test_line.Description = desc;
			test_rows.push(test_line);
			localStorage.setItem("inventorData",JSON.stringify(test_rows));
			existingEntries.push(test_line);
			localStorage.setItem("AllInventors", JSON.stringify(existingEntries));
		}
	 
		if(testimonial_id == "")
		{
			if($('#'.index_id))
			{
				let url =  '/images/avtar.JPG';
				let content = '<div class="card-body"><div class="row p-2"><div class="col-md-1"><img src="'+url+'" /></div><div class="col-md-2"><h5 class="p3">'+companyname+'</h4><h4>'+author+'</h4></div><div class="col-md-9"><h5 class="text-justified">'+desc+'</h5></div></div></div>';
				$('.inventor-'+index_id).html(content);
			}
		}
		else
		{
			if($('.idesc-'.testimonial_id))
			{
				document.getElementById("itestdesc-"+testimonial_id).innerHTML = desc;
			}
			if($('.iauthor-'.testimonial_id))
			{
				document.getElementById("itestauthor-"+testimonial_id).innerHTML = author;
			}
			if($('.icompany-'.testimonial_id))
			{
				document.getElementById("itestcomapny-"+testimonial_id).innerHTML = companyname;
			}
	 
		}
	}
	else
	{
		let formData = new FormData();
		var totalfiles = document.getElementById('modalfile').files.length;
		for (var index = 0; index < totalfiles; index++) 
		{
			formData.append("fileToUpload[]", document.getElementById('modalfile').files[index]);
		}
		formData.append("invention", $("#modalinventionid").val());
		$.ajax(
		{
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url:  '/inventiontestimonialfiles' ,
			type: 'POST',
		 
			data: formData,
			contentType: false,
			processData: false,
			dataType: 'json',
			success: function(response)
			{
				let media = response['media'];
				let url =  '/' + media.mediaLink;
				let path = media.invention_id;
				let test_rows = [];
				let existingEntries = JSON.parse(localStorage.getItem("AllInventors"));
				if(existingEntries == null)
				{
					existingEntries = [];
				} 
				let temp = [];
				if(existingEntries.length != 0)
				{
					for(i = 0; i < existingEntries.length; i++)
					{
						if(existingEntries[i]['templateTestimonial'] == index_id)
						{
							temp = existingEntries[i];
							existingEntries.splice(i,1);
					 
						}
					}
				}
				if(temp.length != '0')
				{
					if(temp['templateTestimonial'] == index_id)
					{
		   
						let test_line = {};
						test_line.testimonial = temp['testimonial'];
						test_line.invention_id = temp['invention_id'];
						test_line.Author = author;
						test_line.templateTestimonial = temp['templateTestimonial'];
						testimonial_id
						test_line.companyName = companyname;
						test_line.Description = desc;
						test_line.fileToUpload = media.mediaLink;
						test_rows.push(test_line);
						localStorage.setItem("inventorData",JSON.stringify(test_rows));
						existingEntries.push(test_line);
						localStorage.setItem("AllInventors", JSON.stringify(existingEntries));
					}
					else
					{
					   let test_line = {};
					   test_line.testimonial = testimonial_id;
					   test_line.invention_id = invention_id;
					   test_line.Author = author;
					   test_line.templateTestimonial = index_id;
					   test_line.companyName = companyname;
					   test_line.Description = desc;
					   test_line.fileToUpload = media.mediaLink;
					   test_rows.push(test_line);
					   localStorage.setItem("inventorData",JSON.stringify(test_rows));
					   existingEntries.push(test_line);
					   localStorage.setItem("AllInventors", JSON.stringify(existingEntries));
					}
				}
				else
				{
					let test_line = {};
					test_line.testimonial = testimonial_id;
					test_line.invention_id = invention_id;
					test_line.Author = author;
					test_line.templateTestimonial = index_id;
					test_line.companyName = companyname;
					test_line.Description = desc;
					test_line.fileToUpload = media.mediaLink;
					test_rows.push(test_line);
					localStorage.setItem("inventorData",JSON.stringify(test_rows));
					existingEntries.push(test_line);
					localStorage.setItem("AllInventors", JSON.stringify(existingEntries));
				}
				if(testimonial_id == "")
				{
					if($('#'.index_id))
					{
						let content = '<div class="card-body"><div class="row p-2"><div class="col-md-1"><img src="'+url+'" /></div><div class="col-md-2"><h5 class="p3">'+companyname+'</h4><h4>'+author+'</h4></div><div class="col-md-9"><h5 class="text-justified">'+desc+'</h5></div></div></div>';
						$('.inventor-'+index_id).html(content);
					}
		  
				}
				else
				{
					if($('.idesc-'.testimonial_id))
					{
						document.getElementById("itestdesc-"+testimonial_id).innerHTML = desc;
					}
					if($('.iauthor-'.testimonial_id))
					{
						document.getElementById("itestauthor-"+testimonial_id).innerHTML = author;
					}
					if($('.icompany-'.testimonial_id))
					{
						document.getElementById("itestcomapny-"+testimonial_id).innerHTML = companyname;
					}
					if($('.iimg-'.testimonial_id))
					{
						$("#iimg-"+testimonial_id).attr("src",url);
					}
				}
	 
			}
		});
	}
	$('#testimonialModal').modal('hide');
	$("#overlay").fadeOut(300);
});
$(document).on("click", ".inventontestimonialblock", function()
{
	let id= $(this).data('tid');
	let tid= $(this).data('tindex');
	let i = 0;
	let invention_id= $(this).data('invention-id');
	let author = "";
	let Description = "";
	let fileToUpload = [];
	let  indexid = "";
	let companyName = "";
	let vendorrowdata = JSON.parse(localStorage.getItem("inventionEntries"));
	if(vendorrowdata == null)
	{
		vendorrowdata = [];
	} 
	let temp = [];
	if(vendorrowdata.length != 0)
	{
		for(i = 0; i < vendorrowdata.length; i++)
		{
			if(vendorrowdata[i]['templateTestimonial'] == tid)
			{
				temp = vendorrowdata[i];
				vendorrowdata.splice(i,1);
			}
		}
	}
	if(temp.length != '0')
	{
		if(temp['templateTestimonial'] == tid)
		{
			author = temp['Author'];
			Description =temp['Description'];
			fileToUpload = temp['fileToUpload'];
			indexid =temp['templateTestimonial'];
			companyName =temp['companyName'];
		}
	}
	$.ajax(
	{
		url:  '/inventiontestimonialsave/' + id +'/'+invention_id + '/'+tid,
		type: 'post',
		data:{"_token": $("input[name='_token']").val(),"author":author,"Description":Description,"fileToUpload":fileToUpload,"indexid":indexid,"companyName" : companyName},
		success: function(response)
		{
			$('#testimonialModal').html(response.html);
			$('#testimonialModal').modal("show");
		}
	});
} );

$(document).on("click", ".inventionupdatetestimonial", function()
{
	localStorage.setItem('inventionkey',true);
	$("#overlay").fadeIn(300);
	let test_line = null;
	let i= 0;
	let author = $("#modalauthor").val();
	let companyname = $("#modalcompanyname").val();
	let desc = $("#modaldesc").val();
	let invention_id = $("#modalinventionid").val();
	let testimonial_id = $("#testid").val();
	let index_id = $("#indexid").val();
	if (document.getElementById('modalfile').value == '')
	{
		if (testimonial_id == "")
		{
			let existingvendordata = JSON.parse(localStorage.getItem("inventionEntries"));
			if (existingvendordata == null)
			{
				existingvendordata = [];
			}
			let temp = [];
			if (existingvendordata.length != 0)
			{
				for (i = 0; i < existingvendordata.length; i++)
				{
					if (existingvendordata[i]['templateTestimonial'] == index_id)
					{
						temp = existingvendordata[i];
						existingvendordata.splice(i, 1);
					}
				}
			}
			if (temp.length != '0')
			{
				if (temp['templateTestimonial'] == index_id)
				{
					if ($('.desc-'.index_id))
					{
						document.getElementById("testdesc-" + index_id).innerHTML = desc;
					}
					if ($('.author-'.index_id))
					{
						document.getElementById("testauthor-" + index_id).innerHTML = author;
					}
					if ($('.company-'.index_id))
					{
						document.getElementById("testcomapny-" + index_id).innerHTML = companyname;
					}
				}
			}
			else
			{
				if ($('#'.index_id))
				{
					let url =   '/images/avtar.JPG';
					let content ='<a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="/images/portfolioImg2.svg"  class="img" id="img-'+index_id+'"><div class="card-body"><h4 class="card-title text_limit_one_line pauthor-'+index_id+' author" data-type="testauthor" data-testindex="4" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-'+index_id+'">'+author+' </h4><p><strong class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-'+index_id+'">'+companyname+'</strong></p><p class="card-text text-justified text-dark fntshowcase text_limit_five_line desc"data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-'+index_id+'">'+desc+'</p></div></a>';
					$('.' + index_id).html(content);
				}
			}
		}
		let test_rows = [];
		let existingEntries = JSON.parse(localStorage.getItem("inventionEntries"));
		if (existingEntries == null)
		{
			existingEntries = [];
		}
		let temp = [];
		if (existingEntries.length != 0)
		{
			for (i = 0; i < existingEntries.length; i++)
			{
				if (existingEntries[i]['templateTestimonial'] == index_id)
				{
					temp = existingEntries[i];
					existingEntries.splice(i, 1);
				}
			}
		}
		if (temp.length != '0')
		{
			if (temp['templateTestimonial'] == index_id)
			{
				test_line = {};
				test_line.testimonial = temp['testimonial'];
				test_line.invention_id = temp['invention_id'];
				test_line.Author = author;
				test_line.templateTestimonial = temp['templateTestimonial'];
				test_line.companyName = companyname;
				test_line.Description = desc;
				test_line.fileToUpload = temp['fileToUpload'];;
				test_rows.push(test_line);
				localStorage.setItem("inventionData", JSON.stringify(test_rows));
				existingEntries.push(test_line);
				localStorage.setItem("inventionEntries", JSON.stringify(existingEntries));
			}
			else
			{
				test_line = {};
				test_line.testimonial = testimonial_id;
				test_line.invention_id = invention_id;
				test_line.Author = author;
				test_line.templateTestimonial = index_id;
				test_line.fileToUpload = null;
				test_line.companyName = companyname;
				test_line.Description = desc;
				test_rows.push(test_line);
				localStorage.setItem("inventionData", JSON.stringify(test_rows));
				existingEntries.push(test_line);
				localStorage.setItem("inventionEntries", JSON.stringify(existingEntries));
			}
		}
		else
		{
			test_line = {};
			test_line.testimonial = testimonial_id;
			test_line.invention_id = invention_id;
			test_line.Author = author;
			test_line.templateTestimonial = index_id;
			test_line.companyName = companyname;
			test_line.fileToUpload = null;
			test_line.Description = desc;
			test_rows.push(test_line);
			localStorage.setItem("inventionData", JSON.stringify(test_rows));
			existingEntries.push(test_line);
			localStorage.setItem("inventionEntries", JSON.stringify(existingEntries));
		}
	}
	else
	{
		let formData = new FormData();
		var totalfiles = document.getElementById('modalfile').files.length;
		for (var index = 0; index < totalfiles; index++)
		{
			formData.append("fileToUpload[]", document.getElementById('modalfile').files[index]);
		}
		formData.append("invention", $("#modalinventionid").val());
		$.ajax(
		{
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url:  '/inventiontestimonialfiles',
			type: 'POST',
			data: formData,
			contentType: false,
			processData: false,
			dataType: 'json',
			success: function(response)
			{
				let media = response['media'];
				let url =  '/' + media.mediaLink;
				let path = media.invention_id;
				let test_rows = [];
				let existingEntries = JSON.parse(localStorage.getItem("inventionEntries"));
				if (existingEntries == null)
				{
					existingEntries = [];
				}
				let temp = [];
				if (existingEntries.length != 0)
				{
					for (i = 0; i < existingEntries.length; i++)
					{
						if (existingEntries[i]['templateTestimonial'] == index_id)
						{
							temp = existingEntries[i];
							existingEntries.splice(i, 1);
						}
					}
				}
				if (temp.length != '0')
				{
					if (temp['templateTestimonial'] == index_id)
					{
						test_line = {};
						test_line.testimonial = temp['testimonial'];
						test_line.invention_id = temp['invention_id'];
						test_line.Author = author;
						test_line.templateTestimonial = temp['templateTestimonial'];
						testimonial_id
						test_line.companyName = companyname;
						test_line.Description = desc;
						test_line.fileToUpload = media.mediaLink;
						test_rows.push(test_line);
						localStorage.setItem("inventionData", JSON.stringify(test_rows));
						existingEntries.push(test_line);
						localStorage.setItem("inventionEntries", JSON.stringify(existingEntries));
					}
					else
					{
						test_line = {};
						test_line.testimonial = testimonial_id;
						test_line.invention_id = invention_id;
						test_line.Author = author;
						test_line.templateTestimonial = index_id;
						test_line.companyName = companyname;
						test_line.Description = desc;
						test_line.fileToUpload = media.mediaLink;
						test_rows.push(test_line);
						localStorage.setItem("inventionData", JSON.stringify(test_rows));
						existingEntries.push(test_line);
						localStorage.setItem("inventionEntries", JSON.stringify(existingEntries));
					}
				}
				else
				{
					test_line = {};
					test_line.testimonial = testimonial_id;
					test_line.invention_id = invention_id;
					test_line.Author = author;
					test_line.templateTestimonial = index_id;
					test_line.companyName = companyname;
					test_line.Description = desc;
					test_line.fileToUpload = media.mediaLink;
					test_rows.push(test_line);
					localStorage.setItem("inventionData", JSON.stringify(test_rows));
					existingEntries.push(test_line);
					localStorage.setItem("inventionEntries", JSON.stringify(existingEntries));
				}
				if (testimonial_id == "")
				{
					if ($('#'.index_id))
					{
						let content = '<a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="'+url+'"  class="img" id="img-'+index_id+'"><div class="card-body"><h4 class="card-title text_limit_one_line pauthor-'+index_id+' author" data-type="testauthor" data-testindex="4" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-'+index_id+'">'+author+' </h4><p><strong class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-'+index_id+'">'+companyname+'</strong></p><p class="card-text text-justified text-dark fntshowcase text_limit_five_line desc"data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-'+index_id+'">'+desc+'</p></div></a>';
						$('.' + index_id).html(content);
					}
				}
				else
				{
					if ($('.desc-'.testimonial_id))
					{
						document.getElementById("testdesc-" + testimonial_id).innerHTML = desc;
					}
					if ($('.author-'.testimonial_id))
					{
						document.getElementById("testauthor-" + testimonial_id).innerHTML = author;
					}
					if ($('.company-'.testimonial_id))
					{
						document.getElementById("testcomapny-" + testimonial_id).innerHTML = companyname;
					}
					if ($('.img-'.testimonial_id))
					{
						$("#img-" + testimonial_id).attr("src", url);
					}
				}
			}
		});
	}
	
	$('#testimonialModal').modal('hide');
	$("#overlay").fadeOut(300);
});


$(document).on("click", ".introjs-donebutton", function()
{
	$(window).scrollTop(10);
});

$(document).on("click", ".cancelinventiondata", function()
{
	if (confirm('Your changes may be discarded. Are you sure you want to leave this page?'))
	{
		let data = localStorage.getItem('newsletterSubscriptionModal');
		let type = localStorage.getItem('type');
		let vendorType = localStorage.getItem('vendorType');
		let email = localStorage.getItem('email');
		let name = localStorage.getItem('name');
		let password = localStorage.getItem('password');
		let category = localStorage.getItem('category');
		localStorage.clear();
		location.reload();
		if(data != null)
		{
			localStorage.setItem('newsletterSubscriptionModal',data);
		}
		if(type != null)
		{
			localStorage.setItem('type',type);
		}
		if(vendorType != null)
		{
			localStorage.setItem('vendorType',vendorType);
		}
		if(email != null)
		{
			localStorage.setItem('email',email);
		}
		if(name != null)
		{
			localStorage.setItem('name',name);
		}
		if(password != null)
		{
			localStorage.setItem('password',password);
		}
		if(category != null)
		{
			localStorage.setItem('category',category);
		}
	}
	else
	{
		e.preventDefault();
	}
	
});



$("select").change(function () 
{
	if($("select option:selected").length > 6)
	{
	  	alert("Yo Can select only 5 Categories");
	  	find("option").removeAttr("selected");
	}
});